import { render, staticRenderFns } from "./UpdateNickname.vue?vue&type=template&id=a950d584&scoped=true&"
import script from "./UpdateNickname.vue?vue&type=script&lang=js&"
export * from "./UpdateNickname.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNickname.vue?vue&type=style&index=0&id=a950d584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a950d584",
  null
  
)

export default component.exports